import React from 'react';
import { Route, Switch } from '@bingads-webui-campaign-react/router';
import { Constants } from '@bingads-webui-campaign/dimensions-grids-config';
import { triggerQualtricsEvent } from '@bingads-webui-campaign/qualtrics';

import { StyledDimensionsPage as DimensionsPage } from './dimensions-page';

const {
  LabelAdgroup,
  LabelKeyword,
  LabelAd,
  TimeHour,
  TimeDay,
  TimeDate,
  TimeWeek,
  TimeMonth,
  TimeQuarter,
  TimeYear,
  SearchQuery,
  UserLocation,
  Geographic,
  AgeGender,
  LandingPage,
  Publisher,
  CallDetails,
  ShoppingCategory,
  ShoppingProductType,
  ShoppingBrand,
  ShoppingItem,
  ShoppingStore,
  LabelCampaign,
  LabelAccount,
} = Constants;

const DimensionsShell = React.memo((props) => {
  try {
    triggerQualtricsEvent('DimensionShellLoaded');
  } catch (e) {
    // Not a severe error
  }

  return (
    <Switch>
      <Route
        exact
        path="/campaign/vnext/dimensions/landingpage"
        render={() => <DimensionsPage {...props} type={LandingPage} reportType="DestinationUrl" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/ageandgender"
        render={() => <DimensionsPage {...props} type={AgeGender} reportType="AgeAndGender" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/searchtermsdimensions"
        render={() => <DimensionsPage {...props} type={SearchQuery} reportType="SearchTerms" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/publisherwebsite"
        render={() => <DimensionsPage {...props} type={Publisher} reportType="PublisherWebsite" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/callforwarding"
        render={() => <DimensionsPage {...props} type={CallDetails} reportType="CallForwardingDetail" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/hour"
        render={() => <DimensionsPage {...props} type={TimeHour} reportType="TimeHourOfDay" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/dayofweek"
        render={() => <DimensionsPage {...props} type={TimeDay} reportType="TimeDayOfWeek" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/date"
        render={() => <DimensionsPage {...props} type={TimeDate} reportType="TimeDate" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/week"
        render={() => <DimensionsPage {...props} type={TimeWeek} reportType="TimeWeek" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/month"
        render={() => <DimensionsPage {...props} type={TimeMonth} reportType="TimeMonth" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/quarter"
        render={() => <DimensionsPage {...props} type={TimeQuarter} reportType="TimeQuarter" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/year"
        render={() => <DimensionsPage {...props} type={TimeYear} reportType="TimeYear" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/reportlabelskeyword"
        render={() => <DimensionsPage {...props} type={LabelKeyword} reportType="KeywordLabelReport" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/reportlabelsad"
        render={() => <DimensionsPage {...props} type={LabelAd} reportType="AdLabelReport" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/reportlabelsadgroup"
        render={() => <DimensionsPage {...props} type={LabelAdgroup} reportType="AdGroupLabelReport" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/reportlabelscampaign"
        render={() => <DimensionsPage {...props} type={LabelCampaign} reportType="CampaignLabelReport" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/reportlabelsaccount"
        render={() => <DimensionsPage {...props} type={LabelAccount} reportType="AccountLabelMccReport" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/geographic"
        render={() => <DimensionsPage {...props} type={Geographic} reportType="Geographic" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/userlocation"
        render={() => <DimensionsPage {...props} type={UserLocation} reportType="UserLocations" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/shoppingcategory"
        render={() => <DimensionsPage {...props} type={ShoppingCategory} reportType="ShoppingCategory" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/shoppingproducttype"
        render={() => <DimensionsPage {...props} type={ShoppingProductType} reportType="ShoppingProductType" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/shoppingbrand"
        render={() => <DimensionsPage {...props} type={ShoppingBrand} reportType="ShoppingBrand" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/shoppingitemid"
        render={() => <DimensionsPage {...props} type={ShoppingItem} reportType="ShoppingItemId" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/shoppingstoreid"
        render={() => <DimensionsPage {...props} type={ShoppingStore} reportType="ShoppingStoreId" />}
      />
      <Route
        exact
        path="/campaign/vnext/dimensions/"
        render={() => <DimensionsPage {...props} type={LandingPage} reportType="DestinationUrl" />}
      />
    </Switch>
  );
});


export { DimensionsShell };
